import { DIALER_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'outboundAbandoned',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Outbound Abandoned',
  },
}

const keys = {
  statKey: 'outbound_abandoned',
  componentKeys: [DIALER_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const outboundAbandoned = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { outboundAbandoned }
